import { CanvasRoutes } from '@/configs/routes/types';

export const DataRoutes = {
  // Data feature routes disabled — hidden from nav; routes commented out in App.tsx
  [CanvasRoutes.Data]: {
    name: 'Data',
    path: '/data',
    showInNavigation: false,
    showInBreadcrumbs: false,
  },
  [CanvasRoutes.DataHome]: {
    name: 'Home',
    path: '/data/home',
    showInNavigation: true,
    showInBreadcrumbs: true,
  },
  [CanvasRoutes.DataCustomers]: {
    name: 'Customers',
    path: '/data/customers',
    showInNavigation: true,
    showInBreadcrumbs: true,
  },
  [CanvasRoutes.DataProducts]: {
    name: 'Products',
    path: '/data/products',
    showInNavigation: true,
    showInBreadcrumbs: true,
  },
  [CanvasRoutes.DataEvents]: {
    name: 'Events',
    path: '/data/events',
    showInNavigation: true,
    showInBreadcrumbs: true,
  },
  [CanvasRoutes.DataQuality]: {
    name: 'Data Quality',
    path: '/data/quality',
    showInNavigation: true,
    showInBreadcrumbs: true,
  },
  [CanvasRoutes.DataTransformations]: {
    name: 'Transformations',
    path: '/data/transformations',
    showInNavigation: true,
    showInBreadcrumbs: true,
  },
};
